var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/nav/\\u0433\\u043B\\u0430\\u0432\\u043D\\u0430\\u044F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,18 C13.5522847,18 14,18.4477153 14,19 L14,19 L14,23 C14,23.5522847 13.5522847,24 13,24 L13,24 L7,24 C6.44771525,24 6,23.5522847 6,23 L6,23 L6,19 C6,18.4477153 6.44771525,18 7,18 L7,18 Z M23,14 C23.5522847,14 24,14.4477153 24,15 L24,15 L24,23 C24,23.5522847 23.5522847,24 23,24 L23,24 L17,24 C16.4477153,24 16,23.5522847 16,23 L16,23 L16,15 C16,14.4477153 16.4477153,14 17,14 L17,14 Z M13,6 C13.5522847,6 14,6.44771525 14,7 L14,7 L14,15 C14,15.5522847 13.5522847,16 13,16 L13,16 L7,16 C6.44771525,16 6,15.5522847 6,15 L6,15 L6,7 C6,6.44771525 6.44771525,6 7,6 L7,6 Z M23,6 C23.5522847,6 24,6.44771525 24,7 L24,7 L24,11 C24,11.5522847 23.5522847,12 23,12 L23,12 L17,12 C16.4477153,12 16,11.5522847 16,11 L16,11 L16,7 C16,6.44771525 16.4477153,6 17,6 L17,6 Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.32fc9227.svg";
export { ForwardRef as ReactComponent };